import { combineReducers } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import userReducer from "./slices/userSlice";
import menuReducer from "./slices/menuSlice";

const rootReducer = combineReducers({
  auth: authReducer,
  user: userReducer,
  menus: menuReducer,
});

export default rootReducer;
